export var DEFAULT_ICON_CONFIGS = {
  theme: 'outline',
  size: '1em',
  strokeWidth: 4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  outStrokeColor: '#000',
  outFillColor: '#2F88FF',
  innerStrokeColor: '#FFF',
  innerFillColor: '#43CCF8'
};